var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BModalForm',_vm._b({ref:"modal",attrs:{"create-default-data":_vm.createDefaultData,"transform-data":_vm.transformData,"max-width":"900px"},on:{"closed":function($event){return _vm.$emit('closed')}},scopedSlots:_vm._u([{key:"title-text",fn:function(ref){
var editable = ref.editable;
var viewOnly = ref.viewOnly;
var form = ref.form;
return [_vm._v(" "+_vm._s(_vm.getTitle(editable || viewOnly, form))+" ")]}},{key:"default",fn:function(ref){
var editable = ref.editable;
var viewOnly = ref.viewOnly;
var form = ref.form;
return [_c('PublicationMunMehForm',{attrs:{"form":form,"publication":_vm.publication,"disabled":editable || viewOnly}})]}},{key:"footer-right",fn:function(ref){
var c = ref.close;
var form = ref.form;
return [_c('v-btn',{attrs:{"text":""},domProps:{"textContent":_vm._s('Создать шаблон формы')},on:{"click":function($event){return _vm.createFormTemplate(form)}}}),_c('v-btn',{attrs:{"text":""},domProps:{"textContent":_vm._s('Отменить')},on:{"click":c}})]}}])},'BModalForm',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }